// extracted by mini-css-extract-plugin
export default {"wrapper":"Scenes_wrapper__b6t+N"};